
import { getPlans } from '@/api/plans';
import AddPlan from './AddPlan.vue';
import { Component, Vue } from 'vue-property-decorator';
import Popup from '@/components/popup.vue';

@Component({
  name: 'Plans',
  components: {
    Popup,
    AddPlan,
  }
})
export default class Plans extends Vue {
  public table: any = {
    id: "plans-table",
    loading: false,
    order: "id",
    columns: [
      {
        text: 'ID',
        value: 'id',
      },
      {
        text: 'Name',
        value: 'name',
        sortable: false
      },
      {
        text: 'Events Limit',
        value: 'app_annual_event_limit',
        sortable: true
      },
      {
        text: 'Attendee Limit',
        value: 'app_annual_attendee_limit',
        sortable: true
      },
      {
        text: 'Event Manager Limit',
        value: 'app_annual_event_manager_limit',
        sortable: true
      },
      {
        text: 'Exhibitor Limit',
        value: 'app_annual_exhibitor_limit',
        sortable: true
      },
      {
        text: 'Price (EUR)',
        value: 'one_time_price_eur',
        sortable: true
      }
    ],
    data: [],
    dialog: false,
  };

  public addPlanPopup: any = {
    isActive: false,
    message: '',
    type: '',
    title: ''
  };


  public loadPlans = () => {
    this.table.loading = true;
    getPlans().then((response: any) => {
      this.table.data = response.data.results;
    }).catch((error) => {
      console.error("Error loading plans:", error);
    }).finally(() => {
      this.table.loading = false;
    });
  };

  public showPopup(message: string, type: string = 'info') {
    this.addPlanPopup.isActive = true;
    this.addPlanPopup.message = message;
    this.addPlanPopup.type = type;

    setTimeout(() => {
      this.addPlanPopup.isActive = false;
      this.addPlanPopup.message = "";
      this.addPlanPopup.type = "";
    }, 5000);
  }

  public handleSubmitComplete = () => {
    this.table.dialog = false;
    this.showPopup('Plan created successfully', 'success');
    this.loadPlans();
  };

  mounted() {
    this.loadPlans();
  }
}
